import { Component, OnInit } from '@angular/core';
import { MessagesService } from '../../messages.service';
import { Router } from '@angular/router';
import { AssetsService } from '../assets.service';
import { LocationsService } from './locations.service';

@Component({
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.css']
})
export class LocationsComponent implements OnInit {
  public locations: any[];
  public loading: boolean;
  public searchDescription: string;
  constructor(private locationsService: LocationsService, private router: Router,private messagesService: MessagesService)  { }

  ngOnInit() {
    this.locations = [];
    this.loadLocations();
  }

  loadLocations() {
    this.loading = true;
    this.locationsService.getLocations('I').subscribe(
        data => {
          this.loading = false; this.locations = data.map(l => ({ id: l.id, description: l.description, active: l.active })); },
        error => { this.loading = false; this.locations = []; this.checkError(error, 'Ha ocurrido un error al cargar las ubicaciones') }
    );
  }

  inactive(locationId: number){
    this.loading = true;
    this.locationsService.inactive(locationId).subscribe(
        data => {          
          this.fillLocations();
        },
        error => { this.checkError(error,"Ha ocurrido un error al inactivar la ubicación") }
        );
  }

  active(locationId: number){
    this.locationsService.active(locationId).subscribe(
        data => this.fillLocations(),
        error => { this.checkError(error,"Ha ocurrido un error al activar la ubicación") }
        );
  }

  search(){
    this.locationsService.search(this.searchDescription).subscribe(
      data => {
        this.loading = false;
        this.locations = data.map(l => ({ id: l.id, description: l.description, active: l.active }));        
      },
      error => {
        this.loading = false;
        this.locations = [];
        this.checkError(error, 'Ha ocurrido un error al cargar las ubicaciones')}
    );
  }
  
  fillLocations(){
    if(this.searchDescription == null && this.searchDescription.trim().length == 0){
      this.loadLocations();
    }else{
      this.search();
    }
  }
  private checkError(error: any, defaultMessage: string) {
    this.messagesService.checkError(error, defaultMessage);
  }

}
